//  import { type } from "os";
import { useParams } from "react-router-dom";
import { types } from "./action-types";

export const isModalVisibleAuth = (params) => ({
  type: types.IS_MODAL_VISIBLE,
  payload: params,
});

export const signUpLoginUpdate = (params) => ({
  type: types.SIGNUP_LOGIN_UPDATE,
  payload: params,
});

export const checkEmailFlow = (params) => ({
  type: types.EMAIL_FLOW_UPDATE,
  payload: params,
});

export const fetchData = (params) => ({
  type: types.SEND_REQUEST_INIT,
  payload: params,
});

export const fetchDataSuccess = (response) => ({
  type: types.SEND_REQUEST_SUCCESS,
  payload: response,
});

export const fetchDataFailure = (error) => ({
  type: types.SEND_REQUEST_FAILURE,
  payload: {},
  error: error,
});

export const updateUserInfo = (params) => ({
  type: types.UPDATE_USER_INFO_INIT,
  payload: params,
});

// fetch search suggestions
export const fetchSearchSuggestions = (params) => ({
  type: types.FETCH_SEARCH_SUGGESTIONS_INIT,
  payload: params,
});

export const fetchSearchSuggestionsFailure = (error) => ({
  type: types.FETCH_SEARCH_SUGGESTIONS_FAILURE,
  payload: {},
  error: error,
});

// //////////////////////////////////////
export const fetchKeywordsInit = (params) => ({
  type: types.FETCH_KEYWORDS_INIT,
  payload: params,
});

export const fetchKeywordsSuccess = (response) => ({
  type: types.FETCH_KEYWORDS_SUCCESS,
  payload: response,
});

export const fetchKeywordsFailure = (error) => ({
  type: types.FETCH_KEYWORDS_FAILURE,
  payload: {},
  error: error,
});



// ////////////////////////////////////////
export const uploadDocument = (params) => ({
  type: types.UPLOAD_DOCUMENT_INIT,
  params,
});

export const uploadDocSuccess = (response) => ({
  type: types.UPLOAD_DOCUMENT_SUCCESS,
  payload: response,
});

export const uploadDocFailure = (error) => ({
  type: types.UPLOAD_DOCUMENT_FAILURE,
  payload: {},
  error: error,
});

export const removeDocument = (params) => ({
  type: types.REMOVE_DOCUMENT_INIT,
  params,
});

export const fetchUserProfile = (payload) => ({
  type: types.FETCH_PROFILE_INIT,
  payload,
});

export const getUrl = () => {
  return {
    type: types.GET_PROFILE_URL,
  };
};

export const resetUserProfile = (params) => {
  return {
    type: types.PROFILE_RESET,
  };
};
export const fetchUserProfileSuccess = (response) => ({
  type: types.FETCH_PROFILE_REQUEST_SUCCESS,
  payload: response,
});

export const fetchUserProfileFailure = (error) => ({
  type: types.FETCH_PROFILE_REQUEST_FAILURE,
  payload: {},
  error: error,
});
export const uploadProfilePic = (params) => ({
  type: types.UPLOAD_PROFILE_PIC_INIT,
  params,
});

export const uploadProfilePicSuccess = (response) => ({
  type: types.UPLOAD_PROFILE_PIC_SUCCESS,
  payload: response,
});

export const uploadProfilePicFailure = (error) => ({
  type: types.UPLOAD_PROFILE_PIC_FAILURE,
  payload: {},
  error: error,
});

// linkedIn login

export const fetchLinkedInToken = (params) => ({
  type: types.LINKEDIN_TOKEN_FETCH,
  payload: params,
});

export const linkedInTokenInit = (params) => {
  return {
    type: types.LINKEDIN_TOKEN_INIT,
    payload: params,
  };
};

// Fetch existing user
export const fetchExistingtUser = (params) => ({
  type: types.CHECK_EXISTING_USER_INIT,
  params,
});

export const fetchExistingUserSuccess = (response) => ({
  type: types.CHECK_EXISTING_USER_SUCCESS,
  payload: response,
});

export const fetchExistingUserFailure = (error) => ({
  type: types.CHECK_EXISTING_USER_FAILURE,
  payload: { valid: false, msg: "User doesn't exist" },
  error: error,
});

export const fetchLinkedInTokenFail = (params) => ({
  type: types.LINKEDIN_TOKEN_FAIL,
  payload: params,
  // error: error,
});

export const fetchSearchSkill = (params) => ({
  type: types.FETCH_SKILLS_INIT,
  params,
});

export const fetchSearchSkillSuccess = (response) => ({
  type: types.FETCH_SKILLS_SUCCESS,
  payload: response,
});

export const createSkillListing = (params) => ({
  type: types.CREATE_SKILL_LISTING_INIT,
  params,
});

export const updateSkillListing = (params) => ({
  type: types.UPDATE_SKILL_LISTING_INIT,
  params,
});

export const updateSkillListingSuccess = (response) => ({
  type: types.UPDATE_SKILL_LISTING_SUCCESS,
  payload: response,
});

export const saveSearchSkill = (params) => ({
  type: types.UPDATE_SKILL_LISTING_SAVE,
  stage: "step4",
  payload: params,
});

// CredentialingForm
export const formSubmitStepOne = (e) => ({
  type: types.STEP_ONE,
  stage: "step1",
  payload: e.target.value,
  key: e.target.name,
});

export const formSubmitSkillListingOne = (e) => ({
  type: types.SKILLISTING,
  stage: "step3",
  payload: e.target.value,
  key: e.target.name,
});

export const formSubmitSkillListingTwo = (e) => ({
  type: types.SKILLISTING,
  stage: "step4",
  payload: e.target.value,
  key: e.target.name,
});

// get location - save location

export const fetchKeySearchLocation = (params) => ({
  type: types.FETCH_SEARCH_LOCATION_INIT,
  payload: params,
});

export const fetchKeySearchDynamicLocation = (params) => {
 return ({
  type: types.FETCH_SEARCH_DYNAMIC_LOCATION_INIT,
  payload: params,
})};
export const fetchKeySearchDynamicLocationSuccess = (params) => ({
  type: types.FETCH_SEARCH_DYNAMIC_LOCATION_SUCCESS,
  payload: params,
});
export const fetchKeySearchDynamicLocationFailure = (params) => ({
  type: types.FETCH_SEARCH_DYNAMIC_LOCATION_FAILURE,
  payload: params,
});

export const fetchKeySearchCompanyAndIndustries = (params) => ({
  type: types.FETCH_SEARCH_COMPANY_AND_INDUSTRIES_INIT,
  payload: params
});

export const fetchKeySearchCompanyAndIndustriesSuccess = (params) => ({
  type: types.FETCH_SEARCH_COMPANY_AND_INDUSTRIES_SUCCESS,
  payload: params
});

export const fetchKeySearchCompanyAndIndustriesFailure = (params) => ({
  type: types.FETCH_SEARCH_COMPANY_AND_INDUSTRIES_FAILURE,
  payload: params
});

export const fetchKeySearchSkills = (params) => ({
  type: types.FETCH_SEARCH_SKILLS_INIT,
  payload: params
});

export const fetchKeySearchSkillsSuccess = (params) => ({
  type: types.FETCH_SEARCH_SKILLS_SUCCESS,
  payload: params
});

export const fetchKeySearchSkillsFailure = (params) => ({
  type: types.FETCH_SEARCH_SKILLS_FAILURE,
  payload: params
});

//region
  export const fetchRegionSuggestionsInit = (params) => ({
    type: types.FETCH_REGION_SUGGESTIONS_INIT,
    payload: params,
  });

  export const fetchRegionSuggestionsSuccess = (params) => ({
    type: types.FETCH_REGION_SUGGESTIONS_SUCCESS,
    payload: params,
  });

  export const fetchRegionSuggestionsFailure = (params) => ({
    type: types.FETCH_REGION_SUGGESTIONS_FAILURE,
    payload: params,
  });
 //state
  export const fetchStateSuggesionsInit = (params) => ({
   
    type: types.FETCH_STATE_SUGGESTIONS_INIT,
    payload: params,
  });
  export const fetchStateSuggesionsSuccess = (params) => ({
    type: types.FETCH_STATE_SUGGESTIONS_SUCCESS,
    payload: params,
  });
  export const fetchStateSuggestionsFailure = (params) => ({
    type: types.FETCH_STATE_SUGGESTIONS_FAILURE,
    payload: params,
  });

export const saveSearchLocationStepOne = (params) => ({
  type: types.FETCH_LOCATION_SAVE,
  stage: "step1",
  payload: params,
});
export const saveExperienceStepOne = (params) => ({
  type: types.FETCH_EXPERIENCE_SAVE,
  stage: "step1",
  payload: params,
});

export const fetchLocationFailure = (error) => ({
  type: types.FETCH_SEARCH_LOCATION_FAILURE,
  payload: {},
  error: error,
});

export const saveSearchLocation = (params) => ({
  type: types.FETCH_SEARCH_LOCATION_SAVE,
  stage: "step4",
  payload: params,
  key: "desiredLocation",
});

// get Discipline - save Discipline

export const fetchKeySearchDiscipline = (params) => ({
  type: types.FETCH_SEARCH_DISCIPLINE_INIT,
  payload: params,
});

export const gotSkillListingFailure = (error) => ({
  type: types.SKILLLISTING_FAILURE,
  payload: {},
  error: error,
});

// export const fetchSkillsDiscipline = (params) => ({
//   type: types.FETCH_SEARCH_DISCIPLINE_SUCCESS,
//   payload: params,
// });

export const saveSearchDiscipline = (params) => ({
  type: types.SEARCH_DISCIPLINE_SAVE,
  stage: "step3",
  payload: params,
});

// Fetching User SkillListing

export const fetchUserSkillListing = () => ({
  type: types.FETCH_USER_SKILLISTING_INIT,
});

export const fetchUserSkillListingSuccess = (params) => ({
  type: types.FETCH_USER_SKILLISTING_SUCCESS,
  payload: params,
  error: {},
});

// SKILL_LISTING COUNTS 
export const skillListingCount = (params) => ({
  type: types.SKILL_LISTING_COUNT_INIT,
  params,
});

export const skillListingCountSuccess = (response) => ({
  type: types.SKILL_LISTING_COUNT_SUCCESS,
  payload: response,
});

export const skillListingCountFailure = (error) => ({
  type: types.SKILL_LISTING_COUNT_FAILURE,
  payload: {},
  error: error,
});

//skilllisting total count
export const skillListingTotalCount = (params) => ({
  type: types.SKILL_LISTING_TOTALCOUNT_INIT,
  params,
});

export const skillListingTotalCountSuccess = (response) => ({
  type: types.SKILL_LISTING_TOTALCOUNT_SUCCESS,
  payload: response,
});

export const skillListingTotalCountFailure = (error) => ({
  type: types.SKILL_LISTING_TOTALCOUNT_FAILURE,
  payload: {},
  error: error,
});

// fetch profile experience
export const fetchProfileExperience = () => ({
  type: types.FETCH_PROFILE_EXPERIENCE_INIT,
});

export const fetchProfileExperienceSuccess = (payload) => ({
  type: types.FETCH_PROFILE_EXPERIENCE_SUCCESS,
  payload: payload,
});

export const createBid = (
  GigId,
  SGFees,
  ActualRate,
  SkillListingId,
  Comments,
  BudgetType,
  Message,
  BidStatusName,
  Rate,
  IdealTerms,
  IdealStartDate,
  permanentJob,
  IdealTermsName
) => {
  return {
    type: types.CREATE_BID_REQUESTED,
    payload: {
      GigId,      
      SGFees,
      ActualRate,
      SkillListingId,
      Comments,
      BudgetType,
      BidStatusName,
      Rate,
      IdealTerms,
      IdealStartDate,
      Message,
      permanentJob, 
      IdealTermsName
    },
  };
};
export const createMultiBid = (params) => {
  return {
    type: types.CREATE_MULTI_BID_REQUESTED,
    payload: params,
  };
};

export const updateBid = (parms) => {
  return {
    type: types.UPDATE_BID_REQUESTED,
    payload: parms,
  };
};
//update proposal
export const updateProposal = (parms) => {
  return {
    type: types.UPDATE_PROPOSAL_REQUESTED,
    payload: parms,
  };
};

export const retractBid = (params) => {
  //console.log('retracted',params);
  return {
    type: types.RETRACT_BID_REQUESTED,
    payload: {
      params,
    },
  };
};

// MESSAGES
// possible types of messages: 'inbox' / 'sentItems'
export const fetchMessages = (messageType, results, skip) => {
  return {
    type: types.FETCH_MESSAGES_REQUESTED,
    payload: {
      type: messageType,
      results,
      skip,
    },
  };
};

export const messagesJobDetails = (params) => {
  return {
    type: types.GET_INBOX_JOB_DETAILS,
    payload: params
  }
}

export const fetchInboxMessages = (conversationType, bidType, bidStatus, page, perPage, hrmId, filter, jobType, jobOrderId, fetchMore, fetchMoreNotification) => {
  return {
    type: types.GET_MESSAGES_INBOX_REQUESTED,
    payload: {
      conversationType,
      bidType,
      bidStatus,
      page,
      perPage,
      hrmId,
      filter,
      jobType, 
      jobOrderId,
      fetchMore
    },
  };
};

export const fetchMessagesCounts = (params) => {
  return {
    type: types.GET_MESSAGES_COUNTS_INIT,
    payload: params
  }
}

export const fetchHRMS = (params) => {
  return {
    type: types.GET_HRM_INIT,
    payload: params
  }
}



// export const sendMessage = (conversationId, recipientId, message, formData) => {
//   return {
//     type: types.SEND_MESSAGE_REQUESTED,
//     payload: {
//       conversationId,
//       recipientId,
//       message,
//       formData,
//     },
//   };
// };

export const sendMessage = (conversationId, recipientId, message, formData) => {
  return {
    type: types.SEND_MESSAGE_REQUESTED,
    payload: {
      conversationId,
      recipientId,
      message,
      formData,
    },
  };
};

//CONVERSATION
export const fetchChatHistory = (id) => {
  console.log("id", id);
  return {
    type: types.FETCH_CHAT_REQUESTED,
    payload: {
      id,
    },
  };
};

export const resetChatHistory = (id) => {
  return {
    type: types.RESET_CHAT_REDUCER,
    payload: {
      id,
    },
  };
};

export const readNotification = (id) => {
  return {
    type: types.READ_NOTIFICATION,
    payload: {
      id,
    },
  };
};
//Interview
//create
// export const createInterview = (
//   SourceId,
//   onModel,
//   InterviewStatus,
//   ClientProfileId,
//   ConsultantProfileId,
//   DeclineReasonId,
//   GigId,
//   SourceTypeName,
//   Reason,
//   ApprovedScheduledTiming,
//   ScheduledTimings
// ) => {
//   return {
//     type: types.CREATE_INTERVIEW_REQUESTED,
//     payload: {
//       SourceId,
//       onModel,
//       InterviewStatus,
//       ClientProfileId,
//       ConsultantProfileId,
//       DeclineReasonId,
//       GigId,
//       SourceTypeName,
//       Reason,
//       ApprovedScheduledTiming,
//       ScheduledTimings,
//     },
//   };
// };

//Interview
//create
export const createInterview = (params) => {

  return {
    type: types.CREATE_INTERVIEW_REQUESTED,
    payload: params,
  };
};

export const fetchDeclinedReasonsBids = (payload) => {
  return {
  type: types.FETCH_DECLINED_REASONS_BIDS_INIT,
  payload,
}};
export const fetchDeclinedReasonsBidsSuccess = (payload) => ({
  type: types.FETCH_DECLINED_REASONS_BIDS_SUCCESS,
  payload,
});
export const fetchDeclinedReasonsBidsFailure = (error) => ({
  type: types.FETCH_DECLINED_REASONS_BIDS_FAILURE,
  error,
});


//update interview
export const updateInterview = (params) => {
  return {
    type: types.UPDATE_INTERVIEW_REQUESTED,
    payload: params,
  };
};

export const fetchProfileDetails = (id) => {
  return {
    type: types.FETCH_PROFILE_DETAILS_REQUESTED,
    payload: {
      id,
    },
  };
};

export const fetchProfileReviews = (payload) => {
  return {
  type: types.FETCH_PROFILE_REVIEWS_REQUESTED,
  payload,
}};
export const fetchProfileReviewsSuccess = (payload) => ({
  type: types.FETCH_PROFILE_REVIEWS_SUCCESS,
  payload,
});
export const fetchProfileReviewsFailure = (error) => ({
  type: types.FETCH_PROFILE_REVIEWS_FAILURE,
  error,
});


export const SearchResponseRequested = (params) => ({
  type: types.SEARCH_LISTING_INIT,
  payload: params,
});
export const SearchResponse = (params) => {
  return {
    type: types.SEARCH_LISTING_SUCCESS,
    payload: params,
  };
};
export const updatePersonalDetails = (
  FirstName,
  LastName,
  PreferredName,
  JobTitle,
  Email,
  MobilePhone,
  AddressLine1,
  AddressLine2,
  Location,
  ZipCode
) => {
  return {
    type: types.UPDATE_PERSONAL_DETAILS_REQUESTED,
    payload: {
      FirstName,
      LastName,
      PreferredName,
      JobTitle,
      Email,
      MobilePhone,
      AddressLine1,
      AddressLine2,
      Location,
      ZipCode,
    },
  };
};

export const SearchValue = (params) => ({
  type: types.SEARCH_VALUE,
  payload: params,
});


export const SearchType = (params) => ({
  type: types.SEARCH_TYPE,
  payload: params,
});

//search Icon clicked
export const SearchIconClicked = (params) => {
    return {
    type: types.SEARCH_ICON_CLICKED,
    payload: params,
  };
};

//clear search icon clicked state
export const ClearSearchIconClicked = (params) => {
    return {
    type: types.CLEAR_SEARCH_ICON_CLICKED,
    payload: params,
  };
};


/////////////////
// MY GIG Filters
export const GetMyGigFilters = (params) => {
  return {
    type: types.MY_GIG_FILTERS_REQUESTED,
    payload: params ?? {},
  };
};
////////////////////
export const GetFilters = (params) => {
  return {
    type: types.GET_FILTERS_REQUESTED,
    payload: params ?? {},
  };
};
export const SearchSuggestions = (params) => {
  return {
    type: types.SEARCH_SUGGESTIONS_REQUESTED,
    payload: params,
  };
};
export const ClearSearchSuggestions = (params) => {
  return {
    type: types.CLEAR_SEARCH_SUGGESTIONS_REQUESTED,
    payload: params,
  };
};

export const FetchAllGigs = (GigName) => {
  return {
    type: types.FETCH_GIGSALL_REQUESTED,
    payload: { GigName },
  };
};

export const getCompanyProfileDetails = () => {
  return {
    type: types.GET_COMPANYPROFILEDETAILS_REQUESTED,
    payload: {},
  };
};


export const getCompanyGigs = () => {
  return {
    type: types.GET_COMPANY_GIGS_INIT,
    payload: {},
  };
};

export const getCompanyGigsSuccess = () => {
  return {
    type: types.GET_COMPANY_GIGS_SUCCESS,
    payload: {},
  };
};
export const getCompanyGigsFailure = () => {
  return {
    type: types.GET_COMPANY_GIGS_FAILURE,
    payload: {},
  };
};






export const updateCompanyProfileLinkedAccounts = (params) => {
  return {
    type: types.UPDATE_COMPANYPROFILELINKEDACCOUNTS_REQUESTED,
    payload: { params },
  };
};

export const updateCompanyProfileLinkedAccountsSuccess = (response) => ({
  type: types.UPDATE_COMPANYPROFILELINKEDACCOUNTS_SUCCESS,
  payload: response,
});

export const updateCompanyProfileLinkedAccountsFailure = (error) => ({
  type: types.UPDATE_COMPANYPROFILELINKEDACCOUNTS_FAILURE,
  payload: {},
  error: error,
});

export const getGigSuggestions = () => {
  return {
    type: types.SEARCH_GIG_SUGGESTION,
    payload: {},
  };
};

//GET PROFILE DETAILS LOCATION
export const getPersonalDetailsLocation = (location) => {
  return {
    type: types.GET_PERSONALDETAILSLOCATION_REQUESTED,
    payload: { location },
  };
};
export const getCompanyDetailsSuggestions = () => {
  return {
    type: types.GET_COMPANY_DETAILS_REQUESTED,
    payload: {},
  };
};

export const updateCompanyProfileDetails = (params) => {
  return {
    type: types.POST_COMPANY_DETAILS_REQUESTED,
    payload: params,
  };
};

export const getRating = (params) => {
  return {
    type: types.GET_RATING_REQUESTED,
    payload: params,
  };
};

export const resetCompanyProfileDetails = (params) => {
  // console.log("post company details", params);
  return {
    type: types.POST_COMPANY_DETAILS_RESET,
  };
};

export const resetTalentProfileDetails = (params) => {
  return {
    type: types.POST_TALENT_DETAILS_RESET,
  };
};

export const getOurCulturePhotos = (type) => {
  return {
    type: types.GET_CULTURE_PHOTOS_REQUESTED,
    payload: type,
  };
};

export const getViews = () => {
  return {
    type: types.GET_VIEWS_REQUESTED,
    payload: {},
  };
};

export const getFollowers = (params) => {
  return {
    type: types.GET_FOLLOWERS_REQUESTED,
    payload: params,
  };
};

//update Employer Profile Albums

export const getEmpAlbums = (params) => {
  return {
    type: types.GET_EMP_ALBUMS_REQUESTED,
    payload: params,
  };
};

export const updateEmpAlbums = (params) => {
  return {
    type: types.UPDATE_EMP_ALBUMS_REQUESTED,
    payload: params,
  };
};
export const updateEmpAlbumsRESET = () => {
  return {
    type: types.UPDATE_EMP_ALBUMS_RESET,
  };
};
export const editEmpAlbums = (params) => {
  return {
    type: types.EDIT_EMP_ALBUMS_REQUESTED,
    payload: params,
  };
};
export const editEmpAlbumsRESET = () => {
  return {
    type: types.EDIT_EMP_ALBUMS_RESET,
  };
};
export const deleteEmpAlbums = (params) => {
  return {
    type: types.DELETE_EMP_ALBUMS_REQUESTED,
    payload: params,
  };
};

//Get Skills
export const getSearchSkills = (params) => {
  return {
    type: types.GET_SEARCH_SKILLS_REQUESTED,
    payload: params,
  };
};

//Get Roles
export const getGigRoles = () => {
  return {
    type: types.GET_GIG_ROLES_REQUESTED,
    payload: {},
  };
};

//Post Gig
export const getGigs = (params) => {
  return {
    type: types.GET_GIG_REQUESTED,
    payload: params,
  };
};

export const createGig = (params) => {
  return {
    type: types.CREATE_GIG_REQUESTED,
    payload: params,
  };
};

export const createGigReset = () => {
  return {
    type: types.CREATE_GIG_RESET,
  };
};

export const resetCreateGig = () => {
  return {
    type: types.CREATE_GIG_RESET,
  };
};

export const updateGig = (params) => {
  return {
    type: types.UPDATE_GIG_REQUESTED,
    payload: { params },
  };
};

export function receivedMessageInit() {
  return {
    type: types.MESSAGE_RECEIVED_INIT,
  };
}

export function receivedMessageSuccess() {
  return {
    type: types.MESSAGE_RECEIVED_SUCCESS,
  };
}export function receivedMessageFailure() {
  return {
    type: types.MESSAGE_RECEIVED_FAILURE,
  };
}

export function receivedMessage(messageObject, sourceType, conversationId) {
  return {
    type: types.MESSAGE_RECEIVED,
    payload: {
      message: messageObject,
      sourceType,
      conversationId,
    },
  };
}
export const sendMessage_Attachment = (response) => {
  return {
    type: types.SEND_MESSAGE_ATTACHMENT_REQUESTED,
    payload: response,
  };
};

export const getCandidateSkillListing = (id) => {
  return {
    type: types.GET_CANDIDATE_SKILLLISTING,
    payload: id,
  };
};

export const getJobListing = (params) => {
  return {
    type: types.GET_JOB_LISTING,
    payload: params,
  };
};

export const getJobListingResult = (params) => {
  return {
    type: types.GET_JOB_RESULT_LISTING,
    payload: params,
  };
};

export const getJobCounts = (params) => {
  return {
    type: types.GET_JOB_COUNTS_REQUESTED,
    payload: params,
  };
};


export const getCandidatesCount = (params) => {
  return {
    type: types.GET_CANDIDATE_COUNTS_REQUESTED,
    payload: params,
  };
};

export const getJobListingDraft = (params) => {
  return {
    type: types.GET_JOB_LISTING_DRAFT,
    payload: params,
  };
};

export const getRecentJobListing = (params) => {
  return {
    type: types.GET_JOB_LISTING_RECENT_REQUESTED,
    payload: params,
  };
};

export const jobListingRESET = () => {
  return {
    type: types.GET_JOB_LISTING_RESET,
  };
};

export const jobListingDraftRESET = () => {
  return {
    type: types.GET_JOB_LISTING_DRAFT_RESET,
  };
};

export const getOneUserSkillListing = (params) => {
  return {
    type: types.GET_ONE_USER_SKILLLISTING_REQUESTED,
    payload: params,
  };
};

export const deleteJob = (params) => {
  return {
    type: types.DELETE_JOB_REQUESTED,
    payload: params,
  };
};

export const getJobTemplates = (params) => {
  return {
    type: types.GET_JOB_TEMPLATES_REQUESTED,
    payload: { type: params?.type, JobOrderTypeName: params?.JobOrderTypeName },
  };
};

//Post a Job Actions
export const updateJobs = (params) => {
  return {
    type: types.UPDATE_JOBS_REQUESTED,
    payload: { params },
  };
};


// Check Unique user Name 


export const checkUsernameUnique = (UserName) => ({

  type: types.CHECK_USERNAME_UNIQUE,

  payload: { UserName },

});



export const checkUsernameUniqueSuccess = (valid) => ({

  type: types.CHECK_USERNAME_UNIQUE_SUCCESS,

  payload: { valid },

});



export const checkUsernameUniqueFail = (error) => ({

  type: types.CHECK_USERNAME_UNIQUE_FAIL,

  payload: { error },

});

//Job Titles
export const getJobTitles = (params) => {
  return {
    type: types.GET_JOB_TITLES_REQUESTED,
    payload: params,
  };
};

export const updateJobsReset = (params) => {
  return {
    type: types.UPDATE_JOBS_RESET,
  };
};

export const getJobDetail = (_id) => {
  return {
    type: types.GET_JOBDETAIL_REQUESTED,
    payload: {
      _id,
    },
  };
};

export const getJobBidDetails =(_id)=>{
  return{
    type: types.GET_JOB_BID_DETAILS,
    payload: {_id}
  }
}

export const clearJobDelSuccess = () => {
  return {
    type: types.CLEAR_JOB_DELETE_SUCCESS,
  };
};

export const clearBidSucess = () => {
  return {
    type: types.CLEAR_BID_SUCCESS,
  };
};

export const clearUserSkillListing = () => {
  return {
    type: types.CLEAR_ONE_USER_SKILLLISTING_SUCCESS,
  };
};

export const clearRetractBid = () => {
  return {
    type: types.CLEAR_RETRACT_BID,
  };
};

export const clearUpdateBidSuccess = () => {
  return {
    type: types.CLEAR_UPDATE_BID_SUCCESS,
  };
};

export const getDashboardDetails = () => {
  return {
    type: types.GET_DASHBOARD_DETAILS_REQUESTED,
    payload: {},
  };
};

export const getDashboardInterview = () => {
  return {
    type: types.GET_DASHBOARD_INTERVIEWS_REQUESTED,
    payload: {},
  };
};

export const getDashboardMatches = () => {
  return {
    type: types.GET_DASHBOARD_MATCHES_REQUESTED,
    payload: {},
  };
};
export const getResume3d = (data) => {
  console.log('inside the 3d resume action', data)
  return {
    type: types.GET_RESUME3D_REQUESTED,
    payload: {
      id: data.id,
      forFollow: data?.forFollow
    },
  };
};
export const getSkillMatches = (gigid) => {
  return {
    type: types.GET_SKILL_MACTHES_REQUESTED,
    payload: {
      gigid,
    },
  };
};
export const getAllInterviews = () => {
  return {
    type: types.GET_ALLINTERVIEWS_REQUESTED,
    payload: {},
  };
};

export const addToMatches = (request) => {
  return {
    type: types.ADD_TO_MATCHES_REQUESTED,
    payload: request,
  };
};
export const addSingleMatches = (request) => {
  return {
    type: types.ADD_SINGLE_MATCHES_REQUESTED,
    payload: request,
  };
};
export const addBatchMatches = (request) => {
  return {
    type: types.ADD_BATCH_MATCHES_REQUESTED,
    payload: request,
  };
};

export const removeFromMatches = (request) => {
  return {
    type: types.REMOVE_FROM_MATCHES_REQUESTED,
    payload: request,
  };
};

export const clearMatchesSuccess = (request) => {
  return {
    type: types.CLEAR_MATCHES_SUCCESS,
    payload: request,
  };
};

export const getFavorites = (currentPage, pageSize,type) => {
  return {
    type: types.GET_FAVORITES_REQUESTED,
    payload: {
      currentPage,
      pageSize,
      type
    },
  };
};


export const addMessageFavorites = (params) => {
  return {
    type: types.GET_MESSAGE_FAVOURITE_REQUESTED,
    payload: params,
  };
};
export const resetMessageFavorites = (params) => {
  return {
    type: types.MESSAGE_FAVOURITE_RESET,
    payload: params,
  }
}

export const addMessageToFavourite = (params) => {
  return {
    type: types.ADD_MESSAGE_TO_FAVOURITE_REQUESTED,
    payload: params,
  };
};


export const removeMessageFromFavourite = (params) => {
  return {
    type: types.REMOVE_MESSAGE_TO_FAVOURITE_REQUESTED,
    payload: params,
  };
};

export const removeMessageFavorites = (params) => {
  return {
    type: types.REMOVE_MESSAGE_FAVOURITE_INTI,
    payload: params,
  };
};

export const FavAdded = (index) => {
  return {
    type: types.FAVOURITE_SUCCESS,
    payload: {
      index,
    },
  };
};
export const FavReset = (params) => {
  return {
    type: types.RESET_ONE_USER_SKILLLISTING_FAVOUTITE,
    payload: params,
  };
};

export const FavRemoved = (index) => {
  return {
    type: types.REMOVE_FAV_SUCCESS,
    payload: {
      index,
    },
  };
};

export const addfollower = (params) => {
  return {
    type: types.POST_FOLLOW_REQUESTED,
    payload: {
      FollowerId: params.id,
      // followercount: params.count
    },
  };
};
export const removefollower = (params) => {
  return {
    type: types.POST_UNFOLLOW_REQUESTED,
    payload: {
      FollowerId: params.id,
    },
  };
};
export const postFavorites = (SourceId) => {
  return {
    type: types.POST_FAVORITES_REQUESTED,
    SourceId,
  };
};
export const deleteFavorites = (SourceId) => {
  return {
    type: types.DELETE_FAVORITES_REQUESTED,
    SourceId,
  };
};
export const approveTimesheet = (id, start, end) => {
  return {
    type: types.APPROVE_TIMESHEET_REQUESTED,
    payload: { id, start, end },
  };
};
export const getTimeSheetList = (params) => {
  return {
    type: types.GET_TIMESHEET_LIST_REQUESTED,
    payload: params,
  };
};
export const getTimesheet = (userAssignmentId, startdate, enddate) => {
  return {
    type: types.GET_TIMESHEET_REQUESTED,
    payload: {
      userAssignmentId,
      startdate,
      enddate,
    },
  };
};

export const rejectTimeSheet = (params) => {
  return {
    type: types.REJECT_TIMESHEET_REQUESTED,
    payload: params,
  };
};

export const getPendingTeamMembers = (params) => {
  return {
    type: types.GET_PENDING_TEAM_REQUESTED,
    payload: params,
  };
};

export const getActiveTeamMembers = (params) => {
  return {
    type: types.GET_ACTIVE_TEAM_REQUESTED,
    payload: params,
  };
};

export const getInActiveTeamMembers = (params) => {
  return {
    type: types.GET_INACTIVE_TEAM_REQUESTED,
    payload: params,
  };
};

export const addTeamMembers = (params) => {
  return {
    type: types.ADD_TEAM_REQUESTED,
    params,
  };
};

export const updateTeamMembers = (inv_id, params) => {
  return {
    type: types.UPDATE_TEAM_REQUESTED,
    inv_id,
    params,
  };
};

export const getMatches = (params) => {
  return {
    type: types.GET_MATCH_REQUESTED,
    payload: params,
  };
};

export const getMatchesSort = (params) => {
  return {
    type: types.GET_MATCH_SORT,
    payload: params,
  };
};

export const SearchCandidateMarketResponseRequested = (params) => ({
  type: types.SEARCH_CANDIDATEMARKET_INIT,
  payload: params,
});
export const SearchCandidateMarketResponse = (params) => {
  return {
    type: types.SEARCH_CANDIDATEMARKET_SUCCESS,
    payload: params,
  };
};

export const SearchCandidateMarketValue = (params) => ({
  type: types.SEARCH_CANDIDATEMARKET_VALUE,
  payload: params,
});

export const addTeamMembersReset = (params) => {
  return {
    type: types.ADD_TEAM_RESET,
    params,
  };
};

export const fetchNotification = (params) => {
  return {
    type: types.GET_NOTIFICATION_REQUESTED,
    payload: params,
  };
};

export const storeData = (params) => {
  return {
    type: types.GET_REDUCER_DATA,
    payload: params,
  };
};

export const fetchNotificationSuccess = (params) => {
  return {
    type: types.GET_NOTIFICATION_SUCCESS,
    payload: params,
  };
};

export const getGraphDetails = (userAssignmentId, type, startdate, enddate) => {
  return {
    type: types.GET_GRAPH_DETAILS_REQUESTED,
    payload: { userAssignmentId, type, startdate, enddate },
  };
};

export const getAllPayments = (type, start, end) => {
  return {
    type: types.GET_ALL_PAYMENTS_REQUESTED,
    payload: { type, start, end },
  };
};

export const reactivateTeamMember = (id) => {
  return {
    type: types.REACTIVATE_TEAM_MEMBER_REQUESTED,
    payload: { id },
  };
};

export const postRatingreviews = (params) => {
  return {
    type: types.POST_RATING_REQUESTED,
    payload: params,
  };
};

export const putRatingreviews = (params) => {
  return {
    type: types.PUT_RATING_REQUESTED,
    payload: params,
  };
};

export const deleteRatingreviews = (params) => {
  return {
    type: types.DELETE_RATING_REQUESTED,
    payload: params,
  };
};

export const clearRatingCheck = () => {
  return {
    type: types.CLEAR_RATING_CHECK
  }
}

export const reactivateTeamMemberSuccess = (response) => ({
  type: types.REACTIVATE_TEAM_MEMBER_REQUESTED_SUCCESS,
  payload: response,
});

export const reactivateTeamMemberFailure = (error) => ({
  type: types.REACTIVATE_TEAM_MEMBER_REQUESTED_FAILURE,
  payload: {},
  error: error,
});

export const getCandidates = (params) => {
  return {
    type: types.GET_CANDIDATES_REQUESTED,
    payload: params,
  };
};

export const getCandidateCount = (params) => {
  return {
    type: types.GET_CANDIDATES_COUNTS_REQUESTED,
    payload: params,
  };
};

export const makeOffer = (params, id) => {
  return {
    type: types.POST_OFFER_REQUESTED,
    payload: {
      id: id,
      data: params,
    },
  };
};
export const editJobOffer = (params, id) => {
  return {
    type: types.EDIT_OFFER_REQUESTED,
    payload: {
      id: id,
      data: params,
    },
  };
};
export const clearEditOfferRes =()=>{
  return{
    type: types.CLEAR_EDIT_OFFER_RESPONSE
  }
}

//
export const fetchRecentSearches = (params) => ({
  type: types.GET_RECENT_SEARCHES_INIT,
  params,
});


export const clearRecentSearchInit = (params) => ({
  type: types.CLEAR_RECENT_SEARCH_INIT,
  params,
});



export const fetchTrendingJobs = (response) => ({
  type: types.GET_TRENDING_JOBS_INIT,
  payload: response,
});

export const fetchFindMyMatches = (params) => {
  return {
    type: types.FIND_MATCH_REQUESTED,
    payload: params,
  };
};

export const matchesReset = () =>{
  return{
    type: types.MATCHES_RESET
  }
}

export const fetchMatchesCount = (params) => {
  return {
    type: types.GET_MATCHES_COUNT,
    payload: params,
  };
};

export const fetchMoreMatches = (params) => {
  return {
    type: types.GET_MORE_MATCHES_INIT,
    payload: params,
  };
};

export const updateImpersonationIdId = (payload) => ({
  type: types.UPDATE_IMPERSONATION_ID,
  payload,
});

export const getAbsAccounts = () => {
  return {
    type: types.GET_ABS_ACCOUNTS
  }
}

export const postNotes = (params) => {
  return {
    type: types.POST_NOTES_REQUESTED,
    payload: params
  }
}

export const getNotes = (params) => {
  return {
    type: types.GET_NOTES_REQUESTED,
    payload: params
  }
}

export const getReminders = () => {
  return {
    type: types.GET_REMINDERS_REQUESTED,
  }
}

export const updateNotes = (params) => {
  return {
    type: types.UPDATES_NOTES_REQUESTED,
    payload: params
  }
}

export const resetUpdateNotes = (params) => {
  return {
    type: types.UPDATES_NOTES_REQUESTED,
    payload: params
  }
}


export const viewIncrement = (params) => {
  return {
    type: types.VIEW_INCREMENT_REQUESTED,
    payload: params
  }
}

export const sendEmailVerification = (params) => {
  return {
    type: types.SEND_EMAIL_VERIFICATION_INIT,
    payload: params,
  };
};

export const getConversationId = (bidid) => {
  return {
    type: types.GET_CONVERSATION_ID_INIT,
    payload: bidid,
  };
};

export const getConversationCountInit = (params) => {
  return {
    type: types.GET_CONVERSATION_COUNT_INIT,
    payload: params,
  };
};

export const getConversationCountSuccess = (params) => {
  return {
    type: types.GET_CONVERSATION_COUNT_SUCCESS,
    payload: params,
  };
};

export const getConversationCountFailure = (params) => {
  return {
    type: types.GET_CONVERSATION_COUNT_FAILURE,
    payload: params,
  };
};

export const wizardFinished =()=>{
  return{
    type: types.WIZARD_FINISHED
  }
}

export const getdraftListInit = (params) => {
  return {
    type: types.GET_JOB_RESULT_LISTING_DRAFT,
    payload: params,
  };
};

export const getdraftListSuccess = (params) => {
  return {
    type: types.GET_JOB_RESULT_LISTING_SUCESS_DRAFT,
    payload: params,
  };
};

export const getdraftListFailure = (params) => {
  return {
    type: types.GET_JOB_RESULT_LISTING_FAILURE_DRAFT,
    payload: params,
  };
};

// MY Gigs FIlters
export const keySearchMyGigsLocation = (params) => ({
  type: types.SEARCH_MY_GIGS_LOCATION_INIT,
  payload: params,
});

export const fetchMyGigsKeySearchSkills = (params) => ({
  type: types.FETCH_MY_GIGS_SEARCH_SKILLS_INIT,
  payload: params
});

export const fetchMyGigsKeySearchSkillsSuccess = (params) => ({
  type: types.FETCH_MY_GIGS_SEARCH_SKILLS_SUCCESS,
  payload: params
});

export const fetchMyGigsKeySearchSkillsFailure = (params) => ({
  type: types.FETCH_MY_GIGS_SEARCH_SKILLS_FAILURE,
  payload: params
});

export const keySearchMyGigsDynamicLocation = (params) => {
 return ({
  type: types.SEARCH_MY_GIGS_DYNAMIC_LOCATION_INIT,
  payload: params,
})};

export const keySearchMyGigsDynamicLocationSuccess = (params) => ({
  type: types.SEARCH_MY_GIGS_DYNAMIC_LOCATION_SUCCESS,
  payload: params,
});

export const keySearchMyGigsDynamicLocationFailure = (params) => ({
  type: types.SEARCH_MY_GIGS_DYNAMIC_LOCATION_FAILURE,
  payload: params,
});

export const savePropsPlaceBid = (params) => {
  return {
    type: types.GET_BID_PLACE_PROPS,
    payload: params,
  };
};

export const removePrivateTalentInit = (params) => ({
  type: types.REMOVE_PRIVATE_MARKET_TALENT,
  payload: params,
});

export const removePrivateTalentFailure = (params) => ({
  type: types.REMOVE_PRIVATE_MARKET_TALENT_FAILURE,
  payload: params,
});

export const removePrivateTalentSuccess = (params) => {
  return {
    type: types.REMOVE_PRIVATE_MARKET_TALENT_SUCCESS,
    payload: params,
  };
};


export const userLanded = (payload) => {
  return ({
    type: types.USER_LANDED,
    payload,
  })
}
export const userClicked = (payload) => {
  return ({
    type: types.USER_CLICK,
    payload,
  })
}

export const getHRMDetailInit = (payload)=>{
  return ({
    type:types.HRM_DETAILS_INIT,
    payload
  })
}
export const getHRMDetailSuccess = (payload)=>{
  return ({
    type:types.HRM_DETAILS_SUCCESS,
    payload
  })
}
export const getHRMDetailFailure = (payload)=>{
  return ({
    type:types.HRM_DETAILS_FAILURE,
    payload
  })
}


export const absDetailInit = (payload)=>{
  return ({
    type:types.ABS_DETAILS_INIT,
    payload
  })
}
export const absDetailSuccess = (payload)=>{
  return ({
    type:types.ABS_DETAILS_SUCCESS,
    payload
  })
}
export const absDetailFailure = (payload)=>{
  return ({
    type:types.ABS_DETAILS_FAILURE,
    payload
  })
}

export const fetchInvitedCandidate = (params)=>{
  return ({
    type:types.FETCH_INVITED_CANDIDATES,
    payload: params,
  })
}
export const fetchInvitedCandidateSuccess = (params)=>{
  return ({
    type:types. FETCH_INVITED_CANDIDATES_SUCCESS,
    payload: params,
  })
}
export const fetchInvitedCandidateFailure = (params)=>{
  return ({
    type:types.FETCH_INVITED_CANDIDATES_FAILURE,
    payload: params,
  })
}
export const fetchCandidateSkillInit = (params) => ({
  type: types.FETCH_CANDIDATE_SKILLS_INIT,
  payload: params,
});

export const fetchCandidateSkillSuccess = (params) => ({
  type: types.FETCH_CANDIDATE_SKILLS_SUCCESS,
  payload: params,
});

export const fetchCandidateSkillFailure = (params) => ({
  type: types.FETCH_CANDIDATE_SKILLS_FAILURE,
  payload: params,
});


export const candidateDetailInit = (payload)=>{
  return ({
    type:types.CANDIDATE_DETAILS_INIT,
    payload
  })
}

export const candidateDetailSuccess = (payload)=>{
  return ({
    type:types.CANDIDATE_DETAILS_SUCCESS,
    payload
  })
}
export const candidateDetailFailure = (payload)=>{
  return ({
    type:types.CANDIDATE_DETAILS_FAILURE,
    payload
  })
}
export const markMessageAsRead = (messageId) => ({
  type: 'MARK_MESSAGE_AS_READ',
  payload: messageId
});
export const resetHeader = () => ({
  type: 'RESET_HEADER_STATE'
});

export const toggleSearchTrue = () => ({
  type: types.TOGGLE_SEARCH_TRUE
});

export const toggleSearchFalse = () => ({
  type: types.TOGGLE_SEARCH_FALSE
});